import { CONSENT_OPTIONS } from '../constants';
import { includes } from 'lodash';
var uploadConsentTypes = [CONSENT_OPTIONS.AUDIO, CONSENT_OPTIONS.DOCUMENT];
function isUploadConsentType(consentType) {
  return includes(uploadConsentTypes, consentType);
}
export default isUploadConsentType;
//# sourceMappingURL=isUploadConsentType.js.map